import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Unauthorized from './pages/Unauthorized';
import ModulePlaceholder from './pages/ModulePlaceholder';
import TenantAuditTrailPage from './pages/TenantAuditTrailPage';
import EmployeePage from './pages/EmployeePage';
import DiscountApprovalInboxPage from './pages/DiscountApprovalInboxPage';
import RegistrationPage from './pages/RegistrationPage';
import AppointmentPage from './pages/appointments/AppointmentPage';
import QueueDeskPage from './pages/queue/QueueDeskPage';
import QueueDisplayPage from './pages/queue/QueueDisplayPage';
import SettlementPage from './pages/SettlementPage';
import CancellationPolicyPage from './pages/CancellationPolicyPage';
import CancellationApprovalsPage from './pages/CancellationApprovalsPage';
import SampleCollectionPage from './pages/SampleCollectionPage';
import SampleReceivePage from './pages/SampleReceivePage';
import PathologyResultPage from './pages/PathologyResultPage';
import RadiologyResultPage from './pages/RadiologyResultPage';
import RegistrationConfigPage from './pages/RegistrationConfigPage';
import TrfConfigPage from './pages/TrfConfigPage';
import CollectionChargePage from './pages/CollectionChargePage';
import BarcodeInventoryPage from './pages/BarcodeInventoryPage';
import ManageNablPage from './pages/nabl/ManageNablPage';
import InvestigationObservationMappingPage from './pages/investigation/InvestigationObservationMappingPage';

// New Enterprise Master Pages
import MasterDirectoryHub from './pages/masters/common/MasterDirectoryHub';
import PanelMasterPage from './pages/masters/PanelMasterPage';
import ReportFormatMasterPage from './pages/masters/ReportFormatMasterPage';
import ProfileMasterPage from './pages/masters/ProfileMasterPage';
import PackageMasterPage from './pages/masters/PackageMasterPage';
import PartyMasterPage from './pages/masters/PartyMasterPage';
import RateContractPage from './pages/masters/RateContractPage';
import InvestigationMasterPageNew from './pages/masters/InvestigationMasterPage';
import ObservationMasterPage from './pages/masters/ObservationMasterPage';
import DepartmentMasterPage from './pages/masters/DepartmentMasterPage';
import SpecimenMasterPage from './pages/masters/SpecimenMasterPage';
import ClinicianMasterPage from './pages/masters/ClinicianMasterPage';
import CentreMasterPage from './pages/masters/CentreMasterPage';
import PanelRatePage from './pages/masters/PanelRatePage';
import ItemRatePage from './pages/masters/ItemRatePage';
import CentrePanelMappingPage from './pages/masters/CentrePanelMappingPage';
import LocationMasterPage from './pages/masters/LocationMasterPage';
import RolePermissionPage from './pages/masters/RolePermissionPage';
import RadiologyTemplatesMasterPage from './pages/masters/RadiologyTemplatesMasterPage';
import ReferralShareConfigPage from './pages/masters/ReferralShareConfigPage';
import CareCoinsRulesMasterPage from './pages/masters/CareCoinsRulesMasterPage';

// Microbiology Enterprise Pages
import MicrobiologyMastersHub from './pages/masters/microbiology/MicrobiologyMastersHub';
import OrganismMasterPage from './pages/masters/microbiology/OrganismMasterPage';
import AntimicrobialMasterPage from './pages/masters/microbiology/AntimicrobialMasterPage';
import ASTPanelBuilderPage from './pages/masters/microbiology/ASTPanelBuilderPage';
import BreakpointMasterPage from './pages/masters/microbiology/BreakpointMasterPage';
import ExpertRulesMasterPage from './pages/masters/microbiology/ExpertRulesMasterPage';
import QCMasterPage from './pages/masters/microbiology/QCMasterPage';
import BarcodeLabelConfigPage from './pages/masters/microbiology/BarcodeLabelConfigPage';
import BarcodeLabelMasterPage from './pages/masters/BarcodeLabelMasterPage';
import RetentionPolicyPage from './pages/masters/microbiology/RetentionPolicyPage';
import MicrobiologyWorklistPage from './pages/microbiology/MicrobiologyWorklistPage';
import MicrobiologyWorkbenchPage from './pages/microbiology/MicrobiologyWorkbenchPage';
import AntibiogramPage from './pages/microbiology/AntibiogramPage';
// Outsource & Universal Platform Pages
import ReferenceLabMasterPage from './pages/masters/ReferenceLabMasterPage';
import OutsourceMappingPage from './pages/masters/OutsourceMappingPage';
import OutsourceWorklistPage from './pages/outsource/OutsourceWorklistPage';

// Report Approval & Doctor Signature Framework
import ReportApprovalQueuePage from './pages/approval/ReportApprovalQueuePage';
import DoctorSignatureMasterPage from './pages/masters/DoctorSignatureMasterPage';

// Formula Intelligence Module
import FormulaIntelligencePage from './pages/masters/formula/FormulaIntelligencePage';

// Smart Pathology Blood Worksheet & Technician Workbench
import PathologyWorksheetPage from './pages/worksheet/PathologyWorksheetPage';
import WorksheetTemplateMasterPage from './pages/masters/WorksheetTemplateMasterPage';




// B2B Enterprise Modernization & Client Portal Pages
import B2bPortalLayout from './pages/b2b/B2bPortalLayout';
import B2bPortalLoginPage from './pages/b2b/B2bPortalLoginPage';
import B2bPortalDashboardPage from './pages/b2b/B2bPortalDashboardPage';
import B2bPortalOrderHistoryPage from './pages/b2b/B2bPortalOrderHistoryPage';
import B2bPortalInvoicesPage from './pages/b2b/B2bPortalInvoicesPage';
import B2bPortalLedgerStatementPage from './pages/b2b/B2bPortalLedgerStatementPage';
import B2bCorporateBillingPage from './pages/b2b/B2bCorporateBillingPage';
import B2bSpecimenLogisticsPage from './pages/b2b/B2bSpecimenLogisticsPage';

// SaaS Platform Administration Pages
import SaasDashboard from './pages/saas/SaasDashboard';
import TenantManagement from './pages/saas/TenantManagement';
import TenantOnboarding from './pages/saas/TenantOnboarding';
import PlatformHealth from './pages/saas/PlatformHealth';
import PlatformAudit from './pages/saas/PlatformAudit';
import KeyLifecycleManagement from './pages/saas/KeyLifecycleManagement';
import SaasClinicalConfig from './pages/saas/SaasClinicalConfig';
import SaasPlansAndSubscriptions from './pages/saas/SaasPlansAndSubscriptions';
import SaasWalletAndUsage from './pages/saas/SaasWalletAndUsage';
import SaasCentresAndStaff from './pages/saas/SaasCentresAndStaff';
import SaasLifecycleAndControls from './pages/saas/SaasLifecycleAndControls';

import { ThemeProvider } from './context/ThemeContext';
import faceApiService from './services/biometric/faceApiService';
import './App.css';
import './pages/masters/MastersHub.css';

function App() {
  React.useEffect(() => {
    // Pre-warm neural network face models in idle time so Face ID operations are sub-500ms
    if (typeof window !== 'undefined') {
      const prewarm = () => {
        faceApiService.loadModels().catch((e) => console.debug('[Biometrics] Background model prewarm:', e));
      };
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prewarm, { timeout: 3000 });
      } else {
        setTimeout(prewarm, 1000);
      }
    }
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* B2B Dedicated Customer Portal Routes (REQ-B2B-09, REQ-B2B-10) */}
          <Route path="/b2b/login" element={<B2bPortalLoginPage />} />
          <Route path="/b2b/portal" element={<B2bPortalLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<B2bPortalDashboardPage />} />
            <Route path="orders" element={<B2bPortalOrderHistoryPage />} />
            <Route path="invoices" element={<B2bPortalInvoicesPage />} />
            <Route path="ledger" element={<B2bPortalLedgerStatementPage />} />
          </Route>

          {/* Protected Routes inside Main Layout */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />

            {/* Front Desk */}
            <Route
              path="appointments"
              element={
                <ProtectedRoute requiredScreen="APPOINTMENTS">
                  <AppointmentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="queue"
              element={
                <ProtectedRoute requiredScreen="QUEUE">
                  <QueueDeskPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="queue/display"
              element={
                <ProtectedRoute requiredScreen="QUEUE">
                  <QueueDisplayPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="registration"
              element={
                <ProtectedRoute requiredScreen="REGISTRATION" requiredRole="Front Office">
                  <RegistrationPage />
                </ProtectedRoute>
              }
            />

            {/* Phlebotomy */}
            <Route
              path="phlebotomy"
              element={
                <ProtectedRoute requiredScreen="PHLEBOTOMY" requiredRole="Phlebotomist">
                  <SampleCollectionPage />
                </ProtectedRoute>
              }
            />

            {/* Sample Receive / Accessioning */}
            <Route
              path="sample-receive"
              element={
                <ProtectedRoute requiredScreen="SAMPLE_RECEIVE" requiredRole="Lab Technician">
                  <SampleReceivePage />
                </ProtectedRoute>
              }
            />

            {/* Pathology Result Entry & Approval */}
            <Route
              path="pathology-results"
              element={
                <ProtectedRoute requiredScreen="PATHOLOGY_RESULTS" requiredRole="Lab Technician">
                  <PathologyResultPage />
                </ProtectedRoute>
              }
            />

            {/* Smart Pathology Blood Worksheet & Technician Workbench */}
            <Route
              path="pathology/worksheet"
              element={
                <ProtectedRoute>
                  <PathologyWorksheetPage />
                </ProtectedRoute>
              }
            />


            {/* Radiology Result Entry & Approval */}
            <Route
              path="radiology-results"
              element={
                <ProtectedRoute requiredScreen="RADIOLOGY_RESULTS" requiredRole="Radiologist">
                  <RadiologyResultPage />
                </ProtectedRoute>
              }
            />

            {/* Microbiology Worklist & Workbench */}
            <Route
              path="microbiology/worklist"
              element={
                <ProtectedRoute>
                  <MicrobiologyWorklistPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="microbiology/workbench/:testId"
              element={
                <ProtectedRoute>
                  <MicrobiologyWorkbenchPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="microbiology/antibiogram"
              element={
                <ProtectedRoute>
                  <AntibiogramPage />
                </ProtectedRoute>
              }
            />

            {/* Centralized Report Approval & Release Queue */}
            <Route
              path="reports/approval-queue"
              element={
                <ProtectedRoute>
                  <ReportApprovalQueuePage />
                </ProtectedRoute>
              }
            />

            {/* Universal Outsource & Logistics Hub */}
            <Route
              path="outsource/worklist"
              element={
                <ProtectedRoute>
                  <OutsourceWorklistPage />
                </ProtectedRoute>
              }
            />

            {/* Settlement */}
            <Route
              path="settlement"
              element={
                <ProtectedRoute requiredScreen="SETTLEMENT" requiredPermission="settlement">
                  <SettlementPage />
                </ProtectedRoute>
              }
            />

            {/* Referral Settlement, Payouts & Reports -> Redirect to Unified Doctor Tariff & Commission Dashboard */}
            <Route
              path="referral-settlement"
              element={<Navigate to="/masters/referral-share" replace />}
            />
            <Route
              path="referral-reports"
              element={<Navigate to="/masters/referral-share" replace />}
            />

            {/* Discount Approval Workflow & Queue */}
            <Route
              path="discount-approvals"
              element={
                <ProtectedRoute>
                  <DiscountApprovalInboxPage />
                </ProtectedRoute>
              }
            />

            {/* Test Cancellation Policy Engine */}
            <Route
              path="cancellation-policy"
              element={
                <ProtectedRoute requiredScreen="CANCELLATION_POLICY">
                  <CancellationPolicyPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="cancellation-approvals"
              element={
                <ProtectedRoute requiredScreen="CANCELLATION_APPROVALS">
                  <CancellationApprovalsPage />
                </ProtectedRoute>
              }
            />

            {/* Admin Modules */}
            <Route
              path="employees"
              element={
                <ProtectedRoute requiredScreen="EMPLOYEES" requiredRole="ADMINISTRATOR">
                  <EmployeePage />
                </ProtectedRoute>
              }
            />

            {/* B2B Corporate Operations (REQ-B2B-03, 04, 05, 08, 13) */}
            <Route
              path="b2b/corporate-billing"
              element={
                <ProtectedRoute>
                  <B2bCorporateBillingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="b2b/specimen-logistics"
              element={
                <ProtectedRoute>
                  <B2bSpecimenLogisticsPage />
                </ProtectedRoute>
              }
            />

            {/* RBAC Role & Permissions Console */}
            <Route
              path="roles"
              element={
                <ProtectedRoute requiredScreen="ROLES" requiredRole="ADMINISTRATOR">
                  <RolePermissionPage />
                </ProtectedRoute>
              }
            />

            {/* Enterprise Masters Hub & Individual Master Pages */}
            <Route
              path="masters"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <MasterDirectoryHub />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/panels"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <PanelMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/profiles"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <ProfileMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/packages"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <PackageMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/parties"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <PartyMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/contracts"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <RateContractPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/investigations"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <InvestigationMasterPageNew />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/observations"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <ObservationMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/formulas"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <FormulaIntelligencePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/worksheet-templates"
              element={
                <ProtectedRoute>
                  <WorksheetTemplateMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/report-formats"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <ReportFormatMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/departments"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <DepartmentMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/specimens"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <SpecimenMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/clinicians"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <ClinicianMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/doctor-signatures"
              element={
                <ProtectedRoute>
                  <DoctorSignatureMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/centres"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <CentreMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/panel-rates"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <PanelRatePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/item-rates"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <ItemRatePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/centre-panel-mapping"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <CentrePanelMappingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/locations"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <LocationMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/radiology-templates"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <RadiologyTemplatesMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/referral-sources"
              element={<Navigate to="/masters/referral-share" replace />}
            />
            <Route
              path="masters/referral-share"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <ReferralShareConfigPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/carecoins-rules"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <CareCoinsRulesMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/reference-labs"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <ReferenceLabMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/outsource-mappings"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <OutsourceMappingPage />
                </ProtectedRoute>
              }
            />

            {/* Microbiology Enterprise Masters */}
            <Route
              path="masters/microbiology"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <MicrobiologyMastersHub />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/microbiology/organisms"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <OrganismMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/microbiology/antimicrobials"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <AntimicrobialMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/microbiology/panels"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <ASTPanelBuilderPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/microbiology/breakpoints"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <BreakpointMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/microbiology/rules"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <ExpertRulesMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/microbiology/qc"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <QCMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/microbiology/barcodes"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <BarcodeLabelConfigPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/microbiology/retention"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <RetentionPolicyPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/barcode-labels"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <BarcodeLabelMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/barcodes"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <BarcodeLabelMasterPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="masters/printers"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <BarcodeLabelMasterPage />
                </ProtectedRoute>
              }
            />
            <Route path="masters/mapping" element={<Navigate to="/investigation-observation-mapping" replace />} />
            <Route path="masters/nabl" element={<Navigate to="/nabl-config" replace />} />

            <Route path="investigations" element={<Navigate to="/masters/investigations" replace />} />

            <Route
              path="investigation-observation-mapping"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <InvestigationObservationMappingPage />
                </ProtectedRoute>
              }
            />
            <Route path="investigation-mapping" element={<Navigate to="/investigation-observation-mapping" replace />} />

            <Route
              path="nabl-config"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <ManageNablPage />
                </ProtectedRoute>
              }
            />
            <Route path="investigation-report-config" element={<Navigate to="/nabl-config" replace />} />

            <Route
              path="registration-config"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <RegistrationConfigPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="collection-charge"
              element={
                <ProtectedRoute requiredScreen="COLLECTION_CHARGE">
                  <CollectionChargePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="trf-config"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <TrfConfigPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="barcode-inventory"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <BarcodeInventoryPage />
                </ProtectedRoute>
              }
            />


            <Route
              path="employees"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <EmployeePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="audit"
              element={
                <ProtectedRoute requiredRole="ADMINISTRATOR">
                  <TenantAuditTrailPage />
                </ProtectedRoute>
              }
            />

            {/* SaaS Platform Administration Module */}
            <Route
              path="saas/dashboard"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <SaasDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/tenants"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <TenantManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/onboarding"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <TenantOnboarding />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/health"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <PlatformHealth />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/audit"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <PlatformAudit />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/keys"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <KeyLifecycleManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/clinical"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <SaasClinicalConfig />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/plans"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <SaasPlansAndSubscriptions />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/wallet"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <SaasWalletAndUsage />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/centres"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <SaasCentresAndStaff />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/staff"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <SaasCentresAndStaff />
                </ProtectedRoute>
              }
            />
            <Route
              path="saas/lifecycle"
              element={
                <ProtectedRoute requiredPlatformAdmin={true}>
                  <SaasLifecycleAndControls />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Catch-all fallback */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
